import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var NoChildError = function () {
    return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Something went wrong." }), _jsx("h3", { children: "ImageSlider must have at least 1 child." })] }));
};
export default NoChildError;
